import { render, staticRenderFns } from "./draw-setting.vue?vue&type=template&id=378c1edf&"
import script from "./draw-setting.vue?vue&type=script&lang=js&"
export * from "./draw-setting.vue?vue&type=script&lang=js&"
import style0 from "./draw-setting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports